module.exports = __webpack_public_path__ + "img/alert-icon.26757d4f.svg";